<template>
  <div class="col-12 row q-col-gutter-x-sm items-center">
    <model-form-input
      :field="`conditionsRequirements.${minPriceField}`"
      class="col"
      label="Minimum Price"
      type="number"
      value-type="Number"
      step="0.25"
      min="0"
      :prefix="currentCircuit.localeCurrencySymbol"
      :rules="[val => val !== null && val !== '' && val >= 0 || 'Field is required']"
    />
    <model-form-input
      :field="`conditionsRequirements.${maxPriceField}`"
      class="col"
      label="Maximum Price"
      type="number"
      value-type="Number"
      step="0.25"
      min="1"
      :prefix="currentCircuit.localeCurrencySymbol"
      :rules="[val => $_.isNil(val) || val === '' || val >= conditional.conditionsRequirements[minPriceField] || 'Field must be empty or greater than Minimum Price']"
    />
    <model-form-toggle
      v-if="!$_.isNil(excludePriceField)"
      :field="`conditionsRequirements.${excludePriceField}`"
      class="col-4 q-pb-md"
      label="Exclude"
      value-type="Boolean"
    />
  </div>
</template>

<script>
import { CONDITIONS_REQUIREMENTS } from 'src/models/booking-fee-type/BookingFeeType'

export default {
  name: 'PriceConditionForm',
  configuration: ['currentCircuit'],
  props: {
    conditional: {
      type: Object,
      required: true
    },
    minPriceField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.MIN_PRICE
    },
    maxPriceField: {
      type: String,
      default: CONDITIONS_REQUIREMENTS.MAX_PRICE
    },
    excludePriceField: {
      type: String,
      default: null
    }
  }
}

</script>
